import styled from 'styled-components';

export const DealSection = styled.div`
    background: #fff;display: flex;
    :after{
        content: "";
        background: #fff;
        clip-path: polygon(100% 0, 0 100%, 100% 100%);
        padding: 11px;
        position: relative;
        right: 21px;
    }
`;

export const GoDeals = styled.div`
    background: #E9F6EA;
    padding: 4px 20px 4px 16px;
    display: flex;
    align-items: center;
    .goDealsIcon{
        width: 70px; 
        height: 16px;
        margin-right: 4px;
    }
    .goDealTxt{
        font-size: 12px;
        color: #46484D;
    }
`;

export const ImgSection = styled.div`
    display: flex
    flex: 1;
`;

export const LoginSection = styled.span`
    align-items: center;
    justify-content: center;
    display: flex;
    cursor: pointer;
    font-size: 10px;
    color: #148730;
    font-family: quicksand;
    font-weight: 700;
    margin-left: 24px;
`;
